/* eslint-disable max-len */
import { template_translation } from '../lang/TemplateTranslation';
const t = template_translation;

export const template24 = {
  title: t.to('誕生日カード', 'title24'),
  desc: t.to(
    `VRの誕生日カードです、名前や写真を変更してその人のためだけの誕生日カードを作ってプレゼントしてみましょう`,
    'desc24'
  ),
  img: '../public/template/24.png',
  xml: `<xml xmlns="http://www.w3.org/1999/xhtml">
  <variables>
  </variables>
  <comment id="5#-N#%reE@ZB/#QLGycX" x="150" y="493" h="163.27783203125" w="1002.8890380859375">このプログラムには何も入力されていない文字ブロックが挿入されています。
「半角英数字ひらがなカタカナ」に文字入力することで、お誕生日をお祝いしたい人の名前を追加することができます。
※漢字と一部対応していない記号があります。</comment>
  <block type="a-scene-start" id="Di+{k^e$UMbL@N-$l;Kj" x="150" y="-110">
    <field name="is_init">off</field>
    <field name="hasController">on</field>
    <statement name="IN">
      <block type="a-sky" id="kVePeD4,y#%bS@ocHppz">
        <value name="COLOUR">
          <shadow type="color_value_v2" id="FE)w!y=5.,w2X8B1IsWp">
            <field name="COLOUR">#000000</field>
          </shadow>
        </value>
        <next>
          <block type="image_element_v2" id="cFbeJ^S5kbv#e+oUoLmW">
            <field name="path">/public/preset/img/HappyBirthday1.jpg</field>
            <field name="position-x">-4</field>
            <field name="position-y">1</field>
            <field name="position-z">-1</field>
            <value name="ATTR">
              <block type="scale_v2" id="$26{$iiR(H2uH%/e\`[si">
                <field name="scale-x">6.4</field>
                <field name="scale-y">3.6</field>
                <field name="scale-z">0</field>
                <value name="ATTR">
                  <block type="lookat_attribute" id="{ZTL]R6*Q.J4=%ie16Js">
                    <field name="always">true</field>
                    <field name="target">block1</field>
                  </block>
                </value>
              </block>
            </value>
            <next>
              <block type="image_element_v2" id="U0d/Zp0~;gR+LB4S^NFh">
                <field name="path">/public/preset/img/HappyBirthday2.jpg</field>
                <field name="position-x">4</field>
                <field name="position-y">1</field>
                <field name="position-z">-5</field>
                <value name="ATTR">
                  <block type="scale_v2" id="dx8+FSAt4:1CO@7f^xTZ">
                    <field name="scale-x">6.4</field>
                    <field name="scale-y">3.6</field>
                    <field name="scale-z">0</field>
                    <value name="ATTR">
                      <block type="lookat_attribute" id="##DYZsyi$o*asdiT9FEG">
                        <field name="always">true</field>
                        <field name="target">block1</field>
                      </block>
                    </value>
                  </block>
                </value>
                <next>
                  <block type="image_element_v2" id="6V}~Ao1POEC}HI(4Q]x+">
                    <field name="path">/public/preset/img/HappyBirthday3.jpg</field>
                    <field name="position-x">-4</field>
                    <field name="position-y">1</field>
                    <field name="position-z">-9</field>
                    <value name="ATTR">
                      <block type="scale_v2" id="Yn:m/1L6qZ{K.N.(|xO]">
                        <field name="scale-x">6.4</field>
                        <field name="scale-y">3.6</field>
                        <field name="scale-z">0</field>
                        <value name="ATTR">
                          <block type="lookat_attribute" id="Leer2}t\`g]DheSqJvh,2">
                            <field name="always">true</field>
                            <field name="target">block1</field>
                          </block>
                        </value>
                      </block>
                    </value>
                    <next>
                      <block type="image_element_v2" id="wR?RQgW%ZDlU[he-\`u$X">
                        <field name="path">/public/preset/img/HappyBirthday4.jpg</field>
                        <field name="position-x">4</field>
                        <field name="position-y">1</field>
                        <field name="position-z">-13</field>
                        <value name="ATTR">
                          <block type="scale_v2" id="~kP8J[=eW8r7_}Vj3pM^">
                            <field name="scale-x">6.4</field>
                            <field name="scale-y">3.6</field>
                            <field name="scale-z">0</field>
                            <value name="ATTR">
                              <block type="lookat_attribute" id="m)\`Q{\`;HA=.!aK0YU|=Z">
                                <field name="always">true</field>
                                <field name="target">block1</field>
                              </block>
                            </value>
                          </block>
                        </value>
                        <next>
                          <block type="a-camera_v2.1" id="h{q]mZ4N+)o2tK3l9@G(">
                            <field name="position-x">0</field>
                            <field name="position-y">0</field>
                            <field name="position-z">8</field>
                            <field name="click_type">mouse</field>
                            <value name="ATTR">
                              <block type="id_v2" id="-Om[|-4+:-x5#qR4.HkE">
                                <field name="id">block1</field>
                              </block>
                            </value>
                            <next>
                              <block type="entity_element" id="!5HKX_Qn1(nYuH+=8nPM">
                                <value name="ATTR">
                                  <block type="lookat_attribute" id="*z3:l09zAP8tM[|5E%NS">
                                    <field name="always">true</field>
                                    <field name="target">block1</field>
                                  </block>
                                </value>
                                <statement name="IN">
                                  <block type="a-text_v2" id="l+Gn]eyOJE^0[fDsfz~n">
                                    <field name="text">
                                    </field>
                                    <field name="id">block</field>
                                    <field name="position-x">-2</field>
                                    <field name="position-y">3.5</field>
                                    <field name="position-z">0</field>
                                    <value name="COLOUR">
                                      <shadow type="color_value_v2" id="ly_!@P#!o)aZ%idzj^eH">
                                        <field name="COLOUR">#ffffff</field>
                                      </shadow>
                                    </value>
                                    <value name="ATTR">
                                      <block type="scale_v2" id="=1SFLc??Rnwj!WaY7HFd">
                                        <field name="scale-x">3</field>
                                        <field name="scale-y">3</field>
                                        <field name="scale-z">3</field>
                                      </block>
                                    </value>
                                    <next>
                                      <block type="image_element_v2" id="dhnNroRCD~pXfM[By]UW">
                                        <field name="path">/public/preset/img/HappyBirthdayLogo.png</field>
                                        <field name="position-x">0</field>
                                        <field name="position-y">6</field>
                                        <field name="position-z">-1</field>
                                        <value name="ATTR">
                                          <block type="scale_v2" id="[/}PNbSd)+W(spP7TL-y">
                                            <field name="scale-x">7</field>
                                            <field name="scale-y">3</field>
                                            <field name="scale-z">0</field>
                                          </block>
                                        </value>
                                      </block>
                                    </next>
                                  </block>
                                </statement>
                              </block>
                            </next>
                          </block>
                        </next>
                      </block>
                    </next>
                  </block>
                </next>
              </block>
            </next>
          </block>
        </next>
      </block>
    </statement>
  </block>
</xml>
`,
  js_code: ``,
};
